import { INLINE_TEXT_SELECTORS } from "./Selectors";
import IToolConfig from "../types/IToolConfig";

export interface IFilters {
    [key: string]: IToolConfig
}

export const FILTERS: IFilters = {
    'dark-contrast': {
        styles: {
            'color': '#FFF',
            'fill': '#FFF',
            'background-color': '#181818'
        },
        // Every element gets the dark backdrop: any tag left out of a list
        // (Divi puts excerpt text bare inside <article> over a white <div>)
        // keeps its original light background under forced-white text.
        childrenSelector: [''],
        // Inline text elements would paint that backdrop over the previous
        // line's glyphs wherever line-height < the font's content box.
        backgroundResetSelectors: INLINE_TEXT_SELECTORS as string[],
        mainSelector:''
    },
    'light-contrast': {
        styles: {
            'color': '#000',
            'fill': '#000',
            'background-color': '#FFF'
        },
        // Same universal-backdrop + inline-reset treatment as dark-contrast:
        // the inline overlap clips wrapped headings identically (white boxes
        // over black glyphs), and dark-themed sites need every container
        // whitened for the forced-black text to stay readable.
        childrenSelector: [''],
        backgroundResetSelectors: INLINE_TEXT_SELECTORS as string[],
        mainSelector:''
    },
    'high-contrast': {
        styles: {
            'filter': 'contrast(110%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'high-saturation': {
        styles: {
            'filter': 'saturate(110%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'low-saturation': {
        styles: {
            'filter': 'saturate(87%)'
        },
        mainSelector:':not(html):not(body)'
    },
    'monochrome': {
        styles: {
            'filter': 'grayscale(100%)'
        },
        mainSelector:':not(html):not(body)'
    }
}

export default FILTERS